module.exports = __webpack_public_path__ + "0457acc1fe207552cdc62380be26a48a.svg";


//////////////////
// WEBPACK FOOTER
// ./resources/sponsors/mlh.svg
// module id = 49
// module chunks = 0